import React, { FC } from 'react';
import { Button, ButtonGroup } from '@mui/material';
import styles from './MeasureSwitchComponent.module.scss';
import { Measure } from '../../measure-utils';

interface MeasureSwitchComponentProps {
    changeMeasure: (measure: Measure) => void;
    currentMeasure: Measure;
}

const MeasureSwitchComponent: FC<MeasureSwitchComponentProps> = (props) => {
    const { changeMeasure, currentMeasure } = props;
    return (
        <div className={styles.MeasureSwitchComponent} data-testid="MeasureSwitchComponent">
            <ButtonGroup>
                <Button
                    className={currentMeasure === Measure.cm ? styles.ActiveButton : styles.InactiveButton}
                    onClick={() => changeMeasure(Measure.cm)}
                    variant={currentMeasure === Measure.cm ? 'contained' : 'text'}
                >
                    CM
                </Button>
                <Button
                    className={currentMeasure === Measure.mm ? styles.ActiveButton : styles.InactiveButton}
                    onClick={() => changeMeasure(Measure.mm)}
                    variant={currentMeasure === Measure.mm ? 'contained' : 'text'}
                >
                    MM
                </Button>
                <Button
                    className={currentMeasure === Measure.inches ? styles.ActiveButton : styles.InactiveButton}
                    onClick={() => changeMeasure(Measure.inches)}
                    variant={currentMeasure === Measure.inches ? 'contained' : 'text'}
                >
                    Inches
                </Button>
            </ButtonGroup>
        </div>
    );
};

export default MeasureSwitchComponent;
